export default __webpack_public_path__ + "static/media/HDTX_Riwayat Hidup Calon Anggota Direksi 2023-2028.eb1c95bc.pdf";